const collator = new Intl.Collator(undefined, {sensitivity: "base", usage: "sort"});

const sortOptionsByLabel = (options = [], {preserveFirst = false} = {}) => {
    if (!Array.isArray(options)) return [];
    if (options.length === 0) return [];

    const baseArray = preserveFirst ? options.slice(1) : options.slice();
    const fixedItems = preserveFirst ? options.slice(0, 1) : [];

    baseArray.sort((a, b) => collator.compare(a?.label ?? "", b?.label ?? ""));

    return preserveFirst ? [...fixedItems, ...baseArray] : baseArray;
};

export default sortOptionsByLabel;
